import {
  GET_SALE_ADJUSTMENT_COLUMN_VALUE_REQUEST,
  GET_SALE_ADJUSTMENT_COLUMN_VALUE_SUCCESS,
  GET_SALE_ADJUSTMENT_COLUMN_VALUE_ERROR,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SALE_ADJUSTMENT_COLUMN_VALUE_REQUEST:
      return {
        loading: true,
      };
    case GET_SALE_ADJUSTMENT_COLUMN_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SALE_ADJUSTMENT_COLUMN_VALUE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
